// src/contexts/AuthContext.jsx
// -----------------------------------------------------------
// Centralises auth state by wrapping the custom `useAuth()` hook.
// No modal logic here anymore – pages/components decide
// when and how to ask the user to sign-in.
// -----------------------------------------------------------
import React, { createContext, useContext, useMemo, useEffect } from "react";
import { useAuth } from "../hooks/useAuth";

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const auth = useAuth();           // { user, loading, login, logout, ... }

  // Update user when token changes
  useEffect(() => {
    const token = localStorage.getItem("jwt_token");
    if (token && !auth.user) {
      auth.refreshUserWithToken?.(token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* -- Memoise so re-renders only when auth values change -- */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const value = useMemo(() => ({ ...auth }), [auth.user, auth.loading]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

/* convenience hook */
export const useAuthContext = () => useContext(AuthContext);
